import { createAsyncThunk } from '@reduxjs/toolkit';
import { StoreState } from '../../../store/store.interface';
import { ActionStatus } from '../../../common/constants/action-status';
import { openReturn } from '../apis/return.api';
import { ReturnRequestParams } from '../interfaces/return-request.interface';

export const returnOrder = createAsyncThunk(
  'order/return',
  async (params: ReturnRequestParams, thunkAPI) => {
    try {
      return await openReturn(params)
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    } 
  },
  {
    condition: (_: any, {getState}) => {
      const state = getState() as StoreState;
      return ActionStatus.loading !== state.returnState.orderReturn.status;
    },
  }
);